import type { DateInfo, Experience } from '@/features/experiences/types/experience.types';

type ExperiencePeriod = Pick<Experience, 'startDate' | 'endDate' | 'isOngoing'>;
type ExperienceHeadline = ExperiencePeriod & Pick<Experience, 'jobTitle' | 'companyName'>;

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

function formatDatePart(date: DateInfo | null | undefined): string {
  if (!date) return '';
  if (!date.month) return String(date.year);
  return `${MONTH_NAMES[date.month - 1] ?? ''} ${date.year}`.trim();
}

export function formatExperiencePeriod(experience: ExperiencePeriod): string {
  const start = formatDatePart(experience.startDate);
  if (!start) return '';
  const end = experience.isOngoing ? 'Present' : formatDatePart(experience.endDate);
  return end ? `${start}–${end}` : start;
}

export function formatExperienceHeadline(experience: ExperienceHeadline): string {
  const parts = [experience.jobTitle, experience.companyName, formatExperiencePeriod(experience)];
  return parts.filter(Boolean).join(' · ');
}
